import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66919a25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "back-button inline-flex flex-row my-4 ml-2" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "m-auto ml-1" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Back")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createElementVNode("img", {
      src: require('@/assets/images/back_icon.svg'),
      class: "back-button__icon inline-block"
    }, null, 8, _hoisted_2),
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_4
      ], true)
    ])
  ]))
}